<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <svg
    viewBox="0 0 178 178"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
    <title>fashionistas</title>
    <desc>Created with Sketch.</desc>
    <defs>
      <circle
        id="path-1"
        cx="90"
        cy="90"
        r="90" />
    </defs>
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd">
      <g
        id="Desktop-HD"
        transform="translate(-325.000000, -650.000000)">
        <g
          id="fashionistas"
          transform="translate(323.000000, 648.000000)">
          <mask
            id="mask-2"
            fill="white">
            <use xlink:href="#path-1" />
          </mask>
          <g
            id="Oval"
            fill-rule="nonzero" />
          <g
            id="Background"
            mask="url(#mask-2)"
            class="fill-extra-light"
            fill-rule="nonzero">
            <g
              id="Oval"
              transform="translate(2.250000, 2.250000)">
              <circle
                cx="90.3825"
                cy="90.3825"
                r="90" />
            </g>
          </g>
          <g
            id="Scene"
            mask="url(#mask-2)">
            <g transform="translate(-9.000000, 9.000000)">
              <g
                id="Group"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
                transform="translate(0.000000, 24.750000)">
                <path
                  id="Path"
                  d="M148.77,109.5075 L146.52,109.5075 C145.277359,109.5075 144.27,108.500141 144.27,107.2575 L144.27,97.0425 C143.145,97.0425 142.02,97.0425 140.895,97.0425 C139.77,97.0425 138.645,97.0425 137.52,97.0425 L137.52,107.2575 C137.52,108.500141 136.512641,109.5075 135.27,109.5075 L133.02,109.5075 C130.534719,109.5075 128.52,111.522219 128.52,114.0075 L128.52,116.2575 L153.27,116.2575 L153.27,114.0075 C153.27,111.522219 151.255281,109.5075 148.77,109.5075 Z"
                  class="fill-white"
                  fill-rule="nonzero" />
                <path
                  id="Path"
                  d="M165.6,18.54 C162.828771,15.7819274 159.620484,13.5011544 156.105,11.79 L154.0125,16.0425 C151.7625,20.6775 146.115,27.7425 140.895,29.3175 C135.6525,27.7425 130.0275,20.6775 127.755,16.0425 L125.6625,11.79 C122.147016,13.5011544 118.938729,15.7819274 116.1675,18.54 C115.578127,19.1281476 115.36174,19.993694 115.605,20.79 C119.029978,32.9032687 120.726739,45.4396062 120.645,58.0275 L120.645,92.7 C120.822197,93.7660863 121.590095,94.6386968 122.625,94.95 C128.62005,96.334067 134.743272,97.0881583 140.895,97.2 C147.039333,97.0885633 153.155137,96.3344567 159.1425,94.95 C160.177374,94.6321413 160.949342,93.7647607 161.145,92.7 L161.145,57.96 C161.043517,45.3723887 162.732936,32.8343268 166.1625,20.7225 C166.379146,19.9467592 166.164616,19.1143846 165.6,18.54 Z"
                  class="fill-light"
                  fill-rule="nonzero" />
                <path
                  id="Path"
                  d="M165.6,18.54 C162.828771,15.7819274 159.620484,13.5011544 156.105,11.79 L154.0125,16.0425 C151.7625,20.6775 146.115,27.7425 140.895,29.3175 C135.6525,27.7425 130.0275,20.6775 127.755,16.0425 L125.6625,11.79 C122.147016,13.5011544 118.938729,15.7819274 116.1675,18.54 C115.578127,19.1281476 115.36174,19.993694 115.605,20.79 C119.029978,32.9032687 120.726739,45.4396062 120.645,58.0275 L120.645,92.7 C120.822197,93.7660863 121.590095,94.6386968 122.625,94.95 C128.62005,96.334067 134.743272,97.0881583 140.895,97.2 C147.039333,97.0885633 153.155137,96.3344567 159.1425,94.95 C160.177374,94.6321413 160.949342,93.7647607 161.145,92.7 L161.145,57.96 C161.043517,45.3723887 162.732936,32.8343268 166.1625,20.7225 C166.379146,19.9467592 166.164616,19.1143846 165.6,18.54 Z"
                  class="stroke"
                  stroke-width="2.25"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  id="Path"
                  d="M148.77,109.5075 L146.52,109.5075 C145.277359,109.5075 144.27,108.500141 144.27,107.2575 L144.27,97.0425 C143.145,97.0425 142.02,97.0425 140.895,97.0425 C139.77,97.0425 138.645,97.0425 137.52,97.0425 L137.52,107.2575 C137.52,108.500141 136.512641,109.5075 135.27,109.5075 L133.02,109.5075 C130.534719,109.5075 128.52,111.522219 128.52,114.0075 L128.52,116.2575 L153.27,116.2575 L153.27,114.0075 C153.27,111.522219 151.255281,109.5075 148.77,109.5075 Z"
                  class="stroke"
                  stroke-width="2.25"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  id="Path"
                  d="M125.6625,11.8125 L125.6625,11.8125 L127.7325,16.0425 C129.9825,20.6775 135.63,27.7425 140.8725,29.3175 C146.0925,27.7425 151.7175,20.6775 153.99,16.0425 L156.0825,11.8125 L156.0825,11.8125 L148.995,8.82 C148.147213,8.47172841 147.59541,7.64402293 147.6,6.7275 L147.6,2.6325 C147.6,1.38985931 146.592641,0.3825 145.35,0.3825 L136.35,0.3825 C135.107359,0.3825 134.1,1.38985931 134.1,2.6325 L134.1,6.75 C134.100893,7.67205866 133.539122,8.50133857 132.6825,8.8425 L125.595,11.835 L125.6625,11.8125 Z"
                  class="stroke fill-white"
                  stroke-width="2.25"
                  fill-rule="nonzero"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  id="Path"
                  d="M141.5475,64.5075 C133.425,64.5075 125.055,58.275 120.6225,53.415 C120.6225,53.9775 120.6225,65.0025 120.6225,65.205 C124.605,71.1675 132.2775,78.0075 141.525,78.0075 C149.6475,78.0075 156.9375,72.225 161.1225,66.7575 C161.1225,65.205 161.1225,53.91 161.1225,52.3575 C157.005,57.42 149.3775,64.5075 141.5475,64.5075 Z"
                  class="stroke fill-white"
                  stroke-width="2.25"
                  fill-rule="nonzero"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  id="Path"
                  d="M157.6125,56.115 C155.745,58.905 147.3525,70.425 136.6425,71.2575 C129.0375,71.8425 123.03,63.6075 120.645,59.715"
                  class="stroke"
                  stroke-width="2.25"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  id="Path"
                  d="M132.75,8.82 L132.93,9.405 C132.93,9.405 135.585,17.01 140.9175,17.235 C146.2275,17.01 148.8825,9.405 148.8825,9.405 L149.0625,8.82"
                  class="stroke"
                  stroke-width="2.25"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  id="Path"
                  d="M140.895,24.0075 L140.895,24.0075 C139.652359,24.0075 138.645,23.0001407 138.645,21.7575 L138.645,19.5075 C138.645,18.2648593 139.652359,17.2575 140.895,17.2575 L140.895,17.2575 C142.137641,17.2575 143.145,18.2648593 143.145,19.5075 L143.145,21.7575 C143.145,23.0001407 142.137641,24.0075 140.895,24.0075 Z"
                  class="stroke fill-light"
                  stroke-width="2.25"
                  fill-rule="nonzero"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <line
                  id="Path"
                  x1="138.51"
                  y1="30.5775"
                  x2="143.145"
                  y2="36.3825"
                  class="stroke"
                  stroke-width="2.25"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <line
                  id="Path"
                  x1="143.28"
                  y1="30.5775"
                  x2="138.645"
                  y2="36.3825"
                  class="stroke"
                  stroke-width="2.25"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  id="Path"
                  d="M127.755,16.065 L125.6625,11.8125 C124.785,12.24 123.93,12.69 123.0975,13.185 L122.3775,18.1575 C121.702386,22.8697971 123.805338,27.5488663 127.7775,30.1725 C128.683096,30.7920079 129.222523,31.8202903 129.2175,32.9175 L129.2175,34.8525 C129.22319,35.9510836 129.904896,36.9326961 130.932311,37.3217172 C131.959726,37.7107383 133.120618,37.4268084 133.8525,36.6075 L139.7925,28.935 C135,26.7975 129.87,20.385 127.755,16.065 Z"
                  class="stroke fill-light"
                  stroke-width="2.25"
                  fill-rule="nonzero"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  id="Path"
                  d="M154.0575,16.065 L156.1275,11.8125 C157.005,12.24 157.8825,12.69 158.715,13.185 L159.4125,18.1575 C160.086651,22.8643509 157.994258,27.5394034 154.035,30.1725 C153.117773,30.7841243 152.568504,31.8150603 152.5725,32.9175 L152.5725,34.8525 C152.533239,35.9006273 151.875529,36.8254427 150.898351,37.2065418 C149.921174,37.587641 148.811002,37.3522998 148.0725,36.6075 L142.1325,28.935 C146.925,26.7975 151.92,20.385 154.0575,16.065 Z"
                  class="stroke fill-light"
                  stroke-width="2.25"
                  fill-rule="nonzero"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <rect
                  id="Rectangle"
                  class="stroke fill-white"
                  stroke-width="2.25"
                  fill-rule="nonzero"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  x="0.3825"
                  y="116.2575"
                  width="175.5"
                  height="36"
                  rx="2.25" />
                <rect
                  id="Rectangle"
                  class="stroke fill-light"
                  stroke-width="2.25"
                  fill-rule="nonzero"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  x="5.895"
                  y="121.8825"
                  width="163.125"
                  height="29.25"
                  rx="2.25" />
                <path
                  id="Path"
                  d="M52.65,65.385 C55.1461028,70.4142744 60.0471892,73.811908 65.6325,74.385 C71.2178108,73.811908 76.1188972,70.4142744 78.615,65.385 L80.6625,61.1775 C78.3735621,60.0918025 75.9748671,59.2545221 73.5075,58.68 L73.5075,51.0075 L57.7575,51.0075 L57.7575,58.68 C55.2818093,59.2507905 52.8752615,60.0881786 50.58,61.1775 L52.65,65.385 Z"
                  class="fill-white"
                  fill-rule="nonzero" />
                <path
                  id="Path"
                  d="M52.65,65.385 C55.1461028,70.4142744 60.0471892,73.811908 65.6325,74.385 C71.2178108,73.811908 76.1188972,70.4142744 78.615,65.385 L80.6625,61.1775 C78.3735621,60.0918025 75.9748671,59.2545221 73.5075,58.68 L73.5075,51.0075 L57.7575,51.0075 L57.7575,58.68 C55.2818093,59.2507905 52.8752615,60.0881786 50.58,61.1775 L52.65,65.385 Z"
                  class="stroke"
                  stroke-width="2.25"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  id="Path"
                  d="M114.0075,112.68 L112.86,112.68 C112.870919,112.747058 112.870919,112.815442 112.86,112.8825 L112.86,123.93 L113.985,123.93 C117.091602,123.93 119.61,121.411602 119.61,118.305 C119.61,115.198398 117.091602,112.68 113.985,112.68 L114.0075,112.68 Z"
                  class="stroke fill-white"
                  stroke-width="2.25"
                  fill-rule="nonzero"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  id="Path"
                  d="M108,110.6325 C105.991059,110.632509 104.064726,109.832923 102.646302,108.410278 C101.227878,106.987633 100.434021,105.058932 100.44,103.05 L100.44,92.61 C100.46116,79.1655923 92.7475302,66.9078371 80.6175,61.11 L78.5475,65.34 C76.0513972,70.3692744 71.1503108,73.766908 65.565,74.34 C59.9796892,73.766908 55.0786028,70.3692744 52.5825,65.34 L50.5125,61.11 C38.3912341,66.9142993 30.6872003,79.1707166 30.7124379,92.61 L30.7124379,131.4225 C31.1966481,131.071384 31.7794347,130.882372 32.3775,130.8825 L42.5025,130.8825 C43.3799106,130.871799 44.2120401,131.271221 44.7525,131.9625 C44.7525,135.81 44.9325,139.6575 45.225,143.4825 L47.61,160.1325 L85.7475,160.1325 L85.8825,143.4825 C86.5800032,134.79648 86.5800032,126.06852 85.8825,117.3825 L85.8825,117.3825 L85.8825,106.1325 C85.8825,117.316266 94.9487338,126.3825 106.1325,126.3825 L110.6325,126.3825 C111.875141,126.3825 112.8825,125.375141 112.8825,124.1325 L112.8825,112.8825 C112.8825,111.639859 111.875141,110.6325 110.6325,110.6325 L108,110.6325 Z"
                  class="fill-white"
                  fill-rule="nonzero" />
                <path
                  id="Path"
                  d="M108,110.6325 C105.991059,110.632509 104.064726,109.832923 102.646302,108.410278 C101.227878,106.987633 100.434021,105.058932 100.44,103.05 L100.44,92.61 C100.46116,79.1655923 92.7475302,66.9078371 80.6175,61.11 L78.5475,65.34 C76.0513972,70.3692744 71.1503108,73.766908 65.565,74.34 C59.9796892,73.766908 55.0786028,70.3692744 52.5825,65.34 L50.5125,61.11 C38.3912341,66.9142993 30.6872003,79.1707166 30.7124379,92.61 L30.7124379,131.4225 C31.1966481,131.071384 31.7794347,130.882372 32.3775,130.8825 L42.5025,130.8825 C43.3799106,130.871799 44.2120401,131.271221 44.7525,131.9625 C44.7525,135.81 44.9325,139.6575 45.225,143.4825 L47.61,160.1325 L85.7475,160.1325 L85.8825,143.4825 C86.5800032,134.79648 86.5800032,126.06852 85.8825,117.3825 L85.8825,117.3825 L85.8825,106.1325 C85.8825,117.316266 94.9487338,126.3825 106.1325,126.3825 L110.6325,126.3825 C111.875141,126.3825 112.8825,125.375141 112.8825,124.1325 L112.8825,112.8825 C112.8825,111.639859 111.875141,110.6325 110.6325,110.6325 L108,110.6325 Z"
                  class="stroke"
                  stroke-width="2.25"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  id="Path"
                  d="M85.8824915,111.7575 L85.8824915,94.1175 C85.8795402,90.9206258 86.6515858,87.7706796 88.1325,84.9375 L88.1325,84.9375"
                  class="stroke"
                  stroke-width="2.25"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  id="Path"
                  d="M45.3825,111.7575 L45.3825,94.1175 C45.3748721,90.9219083 44.6034334,87.7744384 43.1325,84.9375 L43.1325,84.9375"
                  class="stroke"
                  stroke-width="2.25"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  id="Path"
                  d="M45.3825,117.3825 L45.3825,117.3825 C44.6175331,126.063877 44.572379,134.793674 45.2475,143.4825 L47.6325,160.1325"
                  class="stroke"
                  stroke-width="2.25"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <rect
                  id="Rectangle"
                  class="stroke fill-light"
                  stroke-width="2.25"
                  fill-rule="nonzero"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  x="45.3825"
                  y="109.5075"
                  width="40.5"
                  height="7.875" />
                <path
                  id="Path"
                  d="M32.445,136.5075 L42.57,136.5075 C44.1233009,136.5075 45.3825,135.248301 45.3825,133.695 L45.3825,133.695 C45.3825,132.141699 44.1233009,130.8825 42.57,130.8825 L32.445,130.8825 C30.8916991,130.8825 29.6325,132.141699 29.6325,133.695 L29.6325,133.695 C29.6325,135.248301 30.8916991,136.5075 32.445,136.5075 Z"
                  class="fill-light"
                  fill-rule="nonzero" />
                <path
                  id="Path"
                  d="M57.7575,109.507499 L57.7575,109.507499 C65.0446826,109.505456 72.1239455,111.936479 77.8725,116.415 L79.1325,117.3825"
                  class="stroke"
                  stroke-width="2.25"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
              </g>
              <circle
                id="Oval"
                stroke="none"
                class="fill-white"
                fill-rule="nonzero"
                cx="65.6325"
                cy="11.6325"
                r="11.25" />
              <circle
                id="Oval"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
                cx="65.6325"
                cy="11.6325"
                r="11.25" />
              <path
                id="Path"
                d="M88.1325,52.1325 L88.1325,46.5075 C88.1325,34.0810931 78.0589069,24.0075 65.6325,24.0075 C53.2060931,24.0075 43.1325,34.0810931 43.1325,46.5075 L43.1325,52.1325 C40.6472186,52.1325 38.6325,54.1472186 38.6325,56.6325 C38.6325,59.1177814 40.6472186,61.1325 43.1325,61.1325 L43.4025,61.1325 C45.1453509,72.0516484 54.5638845,80.0860724 65.62125,80.0860724 C76.6786155,80.0860724 86.0971491,72.0516484 87.84,61.1325 L88.1325,61.1325 C90.6177814,61.1325 92.6325,59.1177814 92.6325,56.6325 C92.6325,54.1472186 90.6177814,52.1325 88.1325,52.1325 L88.1325,52.1325 Z"
                class="stroke fill-white"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <circle
                id="Oval"
                stroke="none"
                class="fill-light"
                fill-rule="nonzero"
                cx="52.695"
                cy="61.695"
                r="2.8125" />
              <circle
                id="Oval"
                stroke="none"
                class="fill-light"
                fill-rule="nonzero"
                cx="78.57"
                cy="61.695"
                r="2.8125" />
              <path
                id="Path"
                d="M58.86,67.5 C62.653497,71.066098 68.566503,71.066098 72.36,67.5"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M78.0075,54.3825 C77.4318995,53.0289677 76.1033384,52.1502461 74.6325,52.1502461 C73.1616616,52.1502461 71.8331005,53.0289677 71.2575,54.3825"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M59.985,54.3825 C59.4093995,53.0289677 58.0808384,52.1502461 56.61,52.1502461 C55.1391616,52.1502461 53.8106005,53.0289677 53.235,54.3825"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M91.5075,44.2575 C91.5075,29.9671321 79.9228679,18.3825 65.6324955,18.3825 C51.345,18.3825 38.6324955,29.97 38.6324955,44.2575 L38.6324955,66.0375 C38.6287473,72.4488691 40.9648847,78.6412335 45.2025,83.4525 C45.5310021,83.8358039 46.0778704,83.9470314 46.53,83.7225 C46.9814013,83.5088892 47.2379546,83.0232705 47.16,82.53 C45.6075,72.9 42.075,56.8125 51.4575,49.5 C55.7830226,46.318704 58.818201,41.6860632 60.0075,36.45 C79.1324955,36.45 82.5075,53.325 91.5075,53.325 L91.5075,44.2575 Z"
                stroke="none"
                class="fill-white"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M91.5075,44.2575 C91.5075,29.9671321 79.9228679,18.3825 65.6324955,18.3825 C51.345,18.3825 38.6324955,29.97 38.6324955,44.2575 L38.6324955,66.0375 C38.6287473,72.4488691 40.9648847,78.6412335 45.2025,83.4525 C45.5310021,83.8358039 46.0778704,83.9470314 46.53,83.7225 C46.9814013,83.5088892 47.2379546,83.0232705 47.16,82.53 C45.6075,72.9 42.075,56.8125 51.4575,49.5 C55.7830226,46.318704 58.818201,41.6860632 60.0075,36.45 C79.1324955,36.45 82.5075,53.325 91.5075,53.325 L91.5075,44.2575 Z"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables.scss' as *;

  .fill-extra-light {
    fill: var(--iconColorFaded9);
  }

  .stroke {
    stroke: var(--iconColor);
  }

  .fill-light {
    fill: var(--iconColorFaded6);
  }

  .fill-white {
    fill: #ffffff;
  }
</style>
